var bindPopover = function() {
  var is_touch_device = ("ontouchstart" in window) || window.DocumentTouch && document instanceof DocumentTouch;
  if (!is_touch_device) {

    $('[rel="popover"]').popover({
      content:function() {
        var img = $(this).attr("data-full-image");
        var img1 = $(this).attr("data-full-image1");

        var rotate = String($(this).attr("data-full-image-rotation")).toLowerCase() === 'true';
        var rotate1 = String($(this).attr("data-full-image1-rotation")).toLowerCase() === 'true';

        var clazz = "popover-image";
        if (rotate) {
          clazz = clazz.concat(" popover-image-rotate");
        }

        var clazz1 = "popover-image-backside";
        if (rotate1) {
          clazz1 = clazz1.concat(" popover-image-rotate");
        }

        var result = '';
        result = result.concat(`<div class='${clazz}'><img src='${img}'></div>`)

        if (img1 != null) {
          result = result.concat(`<div class='${clazz1}'><img src='${img1}'></div>`)
        }
        return result

      },
      delayIn:200,
      trigger: "hover",
      placement: 'right',
      fallbackPlacement: "clockwise",
      html: true,
      template: '<div class="popover-card popover"><div class="arrow"></div><div class="popover-body"></div></div>'
      }
    );
  } else {
    $('[rel="popover"]').unbind('click');
    $('[rel="popover"]').on("click", function (e) {
        $('#card-popup-modal-title').text($(this).text());
        $.ajax({
          url: "/card_modal",
          data: {
            card_id: $(this).attr("data-card-id"),
          },
          success: function(result){
          },
          dataType: "script",
        });

        $('#card-popup-modal-image-container').html("<img src='/assets/images/gf/back.jpg' class='price-card-image-image'>");
        $('#card-popup-modal').modal();
        e.preventDefault();
    });
  }
}

$(function(){
  bindPopover();
});

document.addEventListener("turbo:frame-load", function(event) {
  bindPopover();
});

document.addEventListener("turbo:before-stream-render", function(event) {
  const render = event.detail.render;

  // Wrap the default render so we hook in *after* it completes
  event.detail.render = function(streamElement) {
    render(streamElement); // perform the actual DOM update
    bindPopover();         // now run your code
  };
});
window.bindPopover = bindPopover;
